<template>
	<div class="row">
		<div class="col-5 fs-sm">
			Page
			<span class="fw-semibold">
				{{ collections.current_page }}
			</span>
			of
			<span class="fw-semibold">{{ collections.last_page }}</span>
		</div>
		<div class="col-7">
			<nav class="d-block d-sm-none">
				<ul class="pagination pagination-sm justify-content-end flex-wrap">
					<li
						class="page-item"
						:class="{ disabled: collections.prev_page_url === null }"
					>
						<inertia-link :href="collections.prev_page_url" class="page-link">
							<i class="fa fa-long-arrow-alt-left me-1"></i> Prev
						</inertia-link>
					</li>
					<li class="page-item active">
						<inertia-link class="page-link">
							{{ collections.current_page }}
						</inertia-link>
					</li>
					<li
						class="page-item"
						:class="{ disabled: collections.next_page_url === null }"
					>
						<inertia-link :href="collections.next_page_url" class="page-link">
							Next <i class="fa fa-long-arrow-alt-right ms-1"></i>
						</inertia-link>
					</li>
				</ul>
			</nav>
			<nav class="d-none d-sm-block">
				<ul class="pagination pagination-sm justify-content-end">
					<li
						v-for="(link, key) in collections.links"
						:key="key"
						class="page-item"
						:class="{ active: link.active, disabled: !link.url }"
					>
						<inertia-link
							class="page-link"
							:href="link.url"
							v-html="link.label"
						/>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		collections: Object,
	},
}
</script>
